export const getUserProfileData  = state => {
  return state.UserReducer.userProfileData;
}
export const selectAdmissionStatus = state => {
  return state.UserReducer.userDetails.admissionStatus;
};

export const getCustomerId = state => {
  return state.UserReducer.userDetails.customerId;
};

export const getUserId = state => {
  return state.UserReducer.userDetails.userId;
};

export const getDeviceOrientation = state => {
  return state.UserReducer.orientation;
}

export const getLastName = state => {
  return state.UserReducer.userDetails.lastName;
}

export const getFirstName = state => {
  return state.UserReducer.userDetails.firstName;
}

export const getOwnSpeedTestError = state => {
  return state.UserReducer.ownSpeedTestError;
};